import { formatDate } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BulkDTNComponent } from '../../bulkdtn/bulkdtn.component';

const Doccomment_type = (dataItem: any) => new FormGroup({
  'comments': new FormControl(dataItem.comment, [Validators.required])
});

@Component({
  selector: 'app-delayreason',
  templateUrl: './delayreason.component.html',
  styleUrls: ['./delayreason.component.css']
})

export class DelayreasonComponent implements OnInit {
  public gridData: any[] = [];
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;

  public delayReasonList: any[] = [];
  public internalReasonList: any[] = [];
  public externalReasonList: any[] = [];
  public editedRowIndexDist!: number;
  public Doccomment_typeRequired!: boolean | null;
  public otherCommentsRequired!: boolean | null;
  public selectedDocCommentId!: number;
  public formGroup!: FormGroup;
  public selectedCmdType!: string;
  public setIntrselectedId!: number | null;
  public setExtrselectedId!: number | null;
  public setWidth: number = 100;
  public comments!: string;
  public enableFilter = false;
  public enableFullscreen: boolean = false;

  public bulkDTNGroupForm!: FormGroup;
  @ViewChild('docGrid') docGrid!: GridComponent;

  constructor(
    public dialogRef: MatDialogRef<BulkDTNComponent>,
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.gridData = this.data;
    this.gridData.forEach(data => {
      data.comments = '';
      data.delayReason = '';
      data.internalReason = '';
      data.externalReason = '';
    });

    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();

    this.bulkDTNGroupForm = this.formBuilder.group({
      formDisciplineList: new FormControl('', Validators.required),
      formWFList: new FormControl('', Validators.required),
      formStageList: new FormControl('', Validators.required),
      formTaskList: new FormControl('', Validators.required),
    });

    this.delayReasonList = [{ id: 1, commentType: "Internal Reason" }, { id: 2, commentType: "External Reason" }, { id: 3, commentType: "Other" }];

    this.internalReasonList = [{ id: 1, IntrcommentType: "Multi disciplinary coordination" }, { id: 2, IntrcommentType: "Non availability of staff" },
    { id: 3, IntrcommentType: "Delay in interface input" }, { id: 4, IntrcommentType: "Delay in Internal review" }, { id: 5, IntrcommentType: "Delayed approval from ECD" },
    { id: 6, IntrcommentType: "Hardware Issues – Printer / Plotter" }, { id: 7, IntrcommentType: "Wrongly entered schedule date" },
    { id: 8, IntrcommentType: "Drawing released through manual transmittal" }, { id: 9, IntrcommentType: "Drawing revised during workflow in progress" }];

    this.externalReasonList = [{ id: 1, ExtrcommentType: "Delay in Client Input" }, { id: 2, ExtrcommentType: "Delay in Vendor Input" },
    { id: 3, ExtrcommentType: "Delayed approval from Client / Consultant" }, { id: 4, ExtrcommentType: "Delayed receipt of vendor clearance / approval" }]

    this.dtnPreparation();
  }

  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  setValues(event: { value: any; }, formControlName: string) {
    this.bulkDTNGroupForm.get(formControlName)?.setValue(event.value);
  }

  async dtnPreparation() {
    for (let i = 0; i <= this.gridData.length; i++) {
      let dueOn = this.gridData[i].scheduledOn;
      let doDate = formatDate(dueOn, 'yyyy-MM-dd', 'en-US');
      let today = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
      if (today > doDate) {
        this.gridData[i]["isDelayed"] = true;
        this.editRowDynamic(i, this.gridData[i]);
      }
      else {
        this.gridData[i]["isDelayed"] = false;
        this.editRowDynamic(i, this.gridData[i])
      }
    }
  }

  closeDialog(data?: any) {
    this.dialogRef.close(data);
  }

  onHover(input: any) {
  }

  editRowData(input: any) {
  }

  UpdateRowData(input: any) {
  }

  cancelRowData(input: any) {
    input.sender.closeRow(input.rowIndex);
    this.setWidth = 100;
  }

  editRowDynamic(rowIndex: number, dataItem: any) {
    dataItem.Doccomment_typeRequired = null;
    dataItem.otherCommentsRequired = null;
    this.setWidth = 400;
    this.formGroup = Doccomment_type(dataItem);
    this.editedRowIndexDist = rowIndex;
    if (!!dataItem.delayReason) {
      let selectedValue = this.delayReasonList.filter(data => data.commentType == dataItem.delayReason)[0];
      this.selectedDocCommentId = selectedValue.id;
    }

    if (!!dataItem.internalReason) {
      let selectedIntrValue = this.internalReasonList.filter(data => data.IntrcommentType == dataItem.internalReason)[0];
      this.setIntrselectedId = selectedIntrValue.id;
    }

    if (!!dataItem.externalReason) {
      let selectedExValue = this.externalReasonList.filter(data => data.ExtrcommentType == dataItem.externalReason)[0];
      this.setExtrselectedId = selectedExValue.id;
    }

    if (!!dataItem.comments) {
      this.formGroup.get('comments')?.setValue(dataItem.comments)
    }
    this.docGrid.editRow(rowIndex);
  }

  onValueChange(event: { target: { value: any; }; }, dataItem: { [x: string]: any; }) {
    dataItem["selectedCmdType"] = event.target.value;
  }

  onselectedValueChange(event: { value: string; text: string; }, dataItem: any) {
    if (event.value != "-2") {
      dataItem["Doccomment_typeRequired"] = null;
      dataItem["otherCommentsRequired"] = null;
      this.Doccomment_typeRequired = null;
      this.otherCommentsRequired = null;
      if (event.text == "Internal Reason") {
        dataItem["Doccomment_typeRequired"] = true;
      } else if (event.text == "External Reason") {
        dataItem["Doccomment_typeRequired"] = false;
      } else if (event.text == "Other") {
        dataItem["otherCommentsRequired"] = true;
      }
      dataItem["selectedCom"] = event.text;
    } else {
      dataItem["delayReason"] = null;
      dataItem["Doccomment_typeRequired"] = null;
      dataItem["otherCommentsRequired"] = null;
      dataItem["selectedCmdType"] = null;
      dataItem["internalReason"] = null;
      dataItem["externalReason"] = null;
    }
  }

  onIntrValueChange(event: { value: string; text: string; }, rowData: any) {
    if (event.value != "-2") {
      rowData["selectedCmdType"] = "InternalReason -" + event.text;
      this.setExtrselectedId = null;
    } else {
      rowData["selectedCmdType"] = null;
    }
  }

  onExtrValueChange(event: { value: string; text: string; }, rowData: any) {
    if (event.value != "-2") {
      rowData["selectedCmdType"] = "ExternalReason -" + event.text;
      this.setIntrselectedId = null;
    } else {
      rowData["selectedCmdType"] = null;
    }
  }

  saveDelayReason() {
    let validate = this.gridData.some(data => !data.selectedCom || !data.selectedCmdType);
    if (validate) {
      this.notificationService.showToast("Without fill the delayreason can't be able to proceed further", "Warning")
    } else {
      this.closeDialog(this.gridData);
    }
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  copyDelayReason() {
    let isDelayReasonAvilable = this.gridData.some(x => x.selectedCmdType != '' && x.selectedCmdType != null)
    if (isDelayReasonAvilable) {
      let data = this.gridData.filter(x => x.selectedCmdType != '' && x.selectedCmdType != null)
      for (let i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].documentId != data[0].documentId) {
          this.gridData[i].Doccomment_typeRequired = data[0].Doccomment_typeRequired;
          this.gridData[i].otherCommentsRequired = data[0].otherCommentsRequired;
          let selectedComment = data[0].selectedCmdType.split('-');
          if (selectedComment.length == 2 && (selectedComment[0].toUpperCase().trim() == "ExternalReason".toUpperCase().trim() || selectedComment[0].toUpperCase().trim() == "InternalReason".toUpperCase().trim())) {
            let isExternalOrInternal = selectedComment[0].toUpperCase().trim() == "ExternalReason".toUpperCase().trim() ? "External Reason" : "Internal Reason";

            if (isExternalOrInternal == 'External Reason') {
              this.selectedDocCommentId = 2
              let selectedExValue = this.externalReasonList.filter(data => data.ExtrcommentType.toUpperCase().trim() == selectedComment[1].toUpperCase().trim())[0]
              this.setExtrselectedId = selectedExValue.id
            }
            else {
              this.selectedDocCommentId = 1
              let selectedIntrValue = this.internalReasonList.filter(data => data.IntrcommentType.toUpperCase().trim() == selectedComment[1].toUpperCase().trim())[0]
              this.setIntrselectedId = selectedIntrValue.id
            }
          }
          else {
            this.selectedDocCommentId = 3
            this.gridData[i].selectedCmdType = data[0].selectedCmdType;
          }
          this.docGrid.editRow(i);
        }
      }
    }
    else {
      this.notificationService.showToast("Fill Delay Reason for atleast one document to copy ", "Warning")
    }
  }
}
